﻿import document from 'document';

import { enableFormSubmission } from '../form/enable-form';

export const conditionHandler = () => {

    const _selectors = {
        root: '.js-contact-module'
    };

    const _getElement = (name) => {
        return document.getElementById(name);
    }
    
    const isObject = obj => {
        return (typeof obj === "object" && obj !== null) || typeof obj === "function";
    };

    const setDisabled = (element, elementCondition) => {
        const condition = isObject(elementCondition) ? elementCondition() : elementCondition;
        console.log(`Disabled ${element.name}  ${condition}`);
        element.disabled = condition;    
    }

    const setRequired = (element, elementCondition) => {
        const isRequired = isObject(elementCondition) ? elementCondition() : elementCondition;
        console.log(`Required ${element.name}  ${isRequired}`);

        if (isRequired)
            element.setAttribute('required', 'required');
        else {
            element.removeAttribute('required');
        }    
    }

    const handleConditionElements = () => {

        const contactType = _getElement('ContactType');
        const preferredTime = _getElement('PreferredTime');
        const preferredDate = _getElement('PreferredDate');

        const handleContactType = () => {
                    
            const conditionFunc = () => contactType.options[contactType.selectedIndex].text.toLowerCase() !== 'call back';
    
            function setElementConditions() {
                const conditionResult = conditionFunc();

                setDisabled(preferredTime, conditionResult);
                setDisabled(preferredDate, conditionResult);

                setRequired(preferredTime, !conditionResult);
                setRequired(preferredDate, !conditionResult);
            }

            contactType.onchange = () => {
                setElementConditions();

                const root = document.querySelector(_selectors.root);
                enableFormSubmission().init(root);
            };
    
            setElementConditions();
        };

        handleContactType();
    }

    const init = () => {
        
        const root = document.querySelector(_selectors.root);
        if (root) {        
            handleConditionElements();
        }
    }

    return {
        init: init
    };
};
